<template>
  <svg
    v-if="country === 'CN'"
    viewBox="0 0 30 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="30" height="20" fill="#de2910" />
    <polygon
      v-for="(pos, i) in cnStars"
      :key="i"
      :points="starPoints"
      :transform="pos"
      fill="#ffde00"
    />
  </svg>
  <svg
    v-else-if="country === 'JP'"
    viewBox="0 0 30 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- 흰 바탕 국기는 밝은 배경에서 묻히므로 얇은 외곽선 추가 -->
    <rect x="0.25" y="0.25" width="29.5" height="19.5" fill="#ffffff" stroke="#999999" stroke-width="0.5" />
    <circle cx="15" cy="10" r="6" fill="#bc002d" />
  </svg>
</template>

<script>
// 5각 별 폴리곤 좌표 (반지름 1, 위쪽 꼭짓점 기준)
const STAR_POINTS = '0,-1 0.2245,-0.309 0.9511,-0.309 0.3633,0.118 0.5878,0.809 0,0.382 -0.5878,0.809 -0.3633,0.118 -0.9511,-0.309 -0.2245,-0.309'

// 국가 추가 시: 해당 국가 SVG 블록을 template 에 추가하고 필요한 좌표를 아래에 정의
export default {
  name: 'CountryFlag',
  props: {
    country: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      starPoints: STAR_POINTS,
      // 중국 국기: 큰 별 1 + 작은 별 4
      cnStars: [
        'translate(5,5) scale(3)',
        'translate(10,2)',
        'translate(12,4)',
        'translate(12,7)',
        'translate(10,9)'
      ]
    }
  }
}
</script>
